import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';


const styles = theme => ({
  cardHeader: {
    //backgroundColor: '#165469',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#fff',
    padding: '5px',
    paddingLeft: '20px',
    fontFamily: 'Flanders Art Sans!important',
    textAlign: 'left',
    fontSize: '1.1em',
    fontWeight: 700,
    borderRadius: '10px',
  },
  
});

function HourCard(props) {
  const { classes } = props;

  /*
  let cardHeaderTitle
  switch (props.lang) {
    case "de":
      cardHeaderTitle = "Énergie en Wallonie aujourd'hui"
      break
    case "en":
      cardHeaderTitle = "Energy in Wallonie today"
      break
    case "fr":
      cardHeaderTitle = "Énergie en Wallonie aujourd'hui"
      break
    case "nl":
    default:
      cardHeaderTitle = "Productie in Vlaanderen"
  }
  */
  const months=["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
  let title = props.currentMode === 'realtime'?('om '+props.activeStep+':00'):('maand '+months[props.activeStep] )
  return (
      <Paper className={classes.cardHeader + ' headerText bgdarkbluegreen'}>
        <div style={{ height: '40px', lineHeight: "40px" }}>
          <div>{title}</div>
        </div>
      </Paper>
  );
}

HourCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HourCard);
